/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gallery_OfferInputs */

const en_us2_gallery_offer = /** @type {(inputs: Gallery_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send to the gallery`)
};

const pt_br2_gallery_offer = /** @type {(inputs: Gallery_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar para a galeria`)
};

const pt_pt2_gallery_offer = /** @type {(inputs: Gallery_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar para a galeria`)
};

/** @type {(inputs: Gallery_OfferInputs) => LocalizedString} */
const es_419_gallery_offer = en_us2_gallery_offer;

/** @type {(inputs: Gallery_OfferInputs) => LocalizedString} */
const fr_fr2_gallery_offer = en_us2_gallery_offer;

/** @type {(inputs: Gallery_OfferInputs) => LocalizedString} */
const de_de2_gallery_offer = en_us2_gallery_offer;

/** @type {(inputs: Gallery_OfferInputs) => LocalizedString} */
const it_it2_gallery_offer = en_us2_gallery_offer;

/**
* | output |
* | --- |
* | "Send to the gallery" |
*
* @param {Gallery_OfferInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const gallery_offer = /** @type {((inputs?: Gallery_OfferInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gallery_OfferInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_gallery_offer(inputs)
	if (locale === "es-419") return es_419_gallery_offer(inputs)
	if (locale === "pt-PT") return pt_pt2_gallery_offer(inputs)
	if (locale === "fr-FR") return fr_fr2_gallery_offer(inputs)
	if (locale === "de-DE") return de_de2_gallery_offer(inputs)
	if (locale === "it-IT") return it_it2_gallery_offer(inputs)
	return en_us2_gallery_offer(inputs)
});
export { gallery_offer as "gallery.offer" }